"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListLabel = exports.StyledList = exports.StyledTabsContent = exports.StyledTabsContentBox = exports.StyledTabsContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledTabsContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledTabsContainer",
  componentId: "sc-1r3i2z7-0"
})(["position:relative;height:100%;"]);

exports.StyledTabsContainer = StyledTabsContainer;

var StyledTabsContentBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledTabsContentBox",
  componentId: "sc-1r3i2z7-1"
})(["overflow-y:auto;height:calc(100% - 80px);padding-right:30px;::-webkit-scrollbar{width:7px;}::-webkit-scrollbar-track{box-shadow:inset 0 0 2px grey;border-radius:10px;background:rgba(0,0,0,0.05);}::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.3);border-radius:10px;}::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,0.4);}"]);

exports.StyledTabsContentBox = StyledTabsContentBox;

var StyledTabsContent = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledTabsContent",
  componentId: "sc-1r3i2z7-2"
})(["display:", ";"], function (props) {
  return props.active ? 'block' : 'none';
});

exports.StyledTabsContent = StyledTabsContent;

var StyledList = _styledComponents["default"].ul.withConfig({
  displayName: "style__StyledList",
  componentId: "sc-1r3i2z7-3"
})(["display:flex;justify-content:flex-start;padding:20px 30px 20px 0;list-style:none;"]);

exports.StyledList = StyledList;

var StyledListLabel = _styledComponents["default"].li.withConfig({
  displayName: "style__StyledListLabel",
  componentId: "sc-1r3i2z7-4"
})(["color:red;margin:0 5px 0 0;&:last-child{margin-right:0;}button[aria-pressed = \"true\"]{border-width:2px !important;}button[aria-pressed = \"false\"]{margin:0 1px;}"]);

exports.StyledListLabel = StyledListLabel;